var widget_default = {
  "card": "v1n-g",
  "link": "QjXgz",
  "container": "TW-yf",
  "image": "nvmg-",
  "right": "_03-QJ",
  "cardLayout": "tSMZz",
  "content": "d0DWN",
  "title": "VMEA3",
  "subtitle": "_7r-fi",
  "button": "uxQfe",
  "button_disabled": "B-jom",
  "buttonText": "MrIYN",
  "slimLayout": "F39-2",
  "contentText": "ieux3"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
